
    export enum EnumGroup {
			Zero = 0,
			One = 1,
			Two = 2,
			TwoTR = 3,
			Three = 4,
			Four = 5,
			FourTR = 6,
			Five = 7,
			Six = 8,
			Seven = 9,
			Eight = 10,
			Nine = 11,
			Ten = 12,
			Eleven = 13,
			Twelve = 14,
			Thirteen = 15,
			Fourteen = 16,
			Fifteen = 17,
			Sixteen = 18,
			Seventeen = 19,
			Eighteen = 20,
			PEN = 21,
			PEND = 22,
    }